module.exports = __webpack_public_path__ + "static/media/walk_board.063a6769.png";